document.addEventListener('DOMContentLoaded', function() {
  // Update cart totals after any change
  const cartItems = document.querySelector('cart-items');
  
  if (cartItems) {
    const observer = new MutationObserver(function() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Update data-subtotal attribute
          cartItems.setAttribute('data-subtotal', cart.total_price);
          
          // Update displayed subtotal
          const subtotalElement = document.querySelector('.totals__subtotal-value');
          if (subtotalElement) {
            subtotalElement.textContent = formatMoney(cart.total_price);
          }
        });
    });
    
    observer.observe(cartItems, {
      childList: true,
      subtree: true
    });
  }
  
  // Format money helper
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2) + ' USD';
  }
});